<template>

<div>

    <h1>Create new Admin</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createAdmin">

        <AdminUserFields />

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create admin user</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import AdminUserFields from '@/components/AdminUser/AdminUserFields.vue'
import Errors from '@/components/Errors.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'AdminUserCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      admin_user: {
       flag:'add'
      },
    }
  },
  components: {
    AdminUserFields,
    Errors
  },
  methods: {
    createAdmin () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'admin-users/handle-user', {
        method: 'POST',
        body: JSON.stringify(this.admin_user),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.status) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$router.push({ name: 'admin-user-index' })
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
